import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '@/store/auth.store';

interface RequirePermissionProps {
  module: string;
  action: string;
  children: ReactNode;
  /**
   * Rendered when permission is missing. Defaults to <Navigate to="/403" replace />.
   * Callers should ensure a /403 route exists in App.tsx or supply a custom fallback.
   */
  fallback?: ReactNode;
}

/**
 * Renders children only if the current user has (module, action) permission.
 * Platform admins always pass. Missing tenant context is treated as permission denied.
 */
export function RequirePermission({ module, action, children, fallback }: RequirePermissionProps) {
  if (!hasPermission(module, action)) {
    return fallback !== undefined ? <>{fallback}</> : <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}
